import { h, render } from "preact";
import DesignersContent from "./designersContent";

class DesignersSection extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.data = window.scrapeSectionData(this);
    this.container = this.querySelector("[data-container]");

    if (!this.container) return;

    render(<DesignersContent data={this.data} />, this.container);
  }

  disconnectedCallback() {}
}

if (!customElements.get("designers-section")) {
  customElements.define("designers-section", DesignersSection);
}
